import {
  Box,
  Divider,
  MenuItem,
  MenuList,
  Popover,
  Typography,
} from "@mui/material";
import { useCallback } from "react";
import { PopoverComponentProps } from "./types";
import { useNavigate } from "react-router-dom";
import { SignoutTrigger } from "../../../domian/app/AppSlice";
import { useDispatch } from "react-redux";

export const PopoverComponent = (props: PopoverComponentProps): JSX.Element => {
  const navigate = useNavigate();
  const { anchorEl, onClose, open } = props;
  const dispatch = useDispatch();
  return (
    <Popover
      anchorEl={anchorEl}
      anchorOrigin={{
        horizontal: "left",
        vertical: "bottom",
      }}
      onClose={onClose}
      open={open}
      PaperProps={{ sx: { width: 200 } }}
    >
      <Box
        sx={{
          py: 1.5,
          px: 2,
        }}
      >
        <Typography variant="overline">Account</Typography>
      </Box>
      <Divider />
      <MenuList
        disablePadding
        dense
        sx={{
          p: "8px",
          "& > *": {
            borderRadius: 1,
          },
        }}
      >
        <MenuItem
          onClick={() => {
            dispatch(SignoutTrigger());
            dispatch({ type: "SIGNOUT_REQUEST" });
            navigate("/");
          }}
        >
          Sign out
        </MenuItem>
      </MenuList>
    </Popover>
  );
};
